import { render, staticRenderFns } from "./DataSharing.vue?vue&type=template&id=66c453b6"
import script from "./DataSharing.vue?vue&type=script&lang=js"
export * from "./DataSharing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports